import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { resolveSupportedLang } from '../../i18n'

/** Wires MarketingHeader's CTA/login actions for pages outside the /:lang/* app (currently the
 *  blog) - AppShell provides its own wiring for the landing page instead, since it also needs to
 *  set customerAuthMode. The "login" vs "register" intent is passed via router state and read by
 *  AppShell's initial customerAuthMode on mount (see App.tsx). */
export function useMarketingHeaderActions() {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const lang = resolveSupportedLang(i18n.resolvedLanguage)

  return {
    onSelectCustomer: () => navigate(`/${lang}/customer`, { state: { authMode: 'register' } }),
    onLoginCustomer: () => navigate(`/${lang}/customer`, { state: { authMode: 'login' } }),
    onLoginCraftsman: () => navigate(`/${lang}/craftsman`),
  }
}
